export default "__VITE_ASSET__CxFbiI0O__"